import React from "react";
import { BankLogoProps } from "./BankLogo.types";
import {
  BANK_ICONS,
  DEFAULT_BANK_ICON,
  IMAGE_PREFIX,
  transformMedia,
} from "../../../utils/constants";
import { BankLogoWrapper } from "./BankLogo.styles";

export const BankLogo: React.FC<BankLogoProps> = ({
  ifsc,
  dataCy = "bank-logo",
  height = 40,
  width = 40,
}) => {
  // Helper function to get bank icon
  const getBankIcon = (ifsc: string): string => {
    return BANK_ICONS[ifsc as keyof typeof BANK_ICONS] || DEFAULT_BANK_ICON;
  };
  const bankIconPath = getBankIcon(ifsc);
  // Check if using default bank icon
  const isDefaultIcon = !BANK_ICONS[ifsc as keyof typeof BANK_ICONS];

  return (
    <BankLogoWrapper
      src={transformMedia(`${IMAGE_PREFIX}${bankIconPath}`)}
      alt={`Bank logo for IFSC: ${ifsc}`}
      data-cy={dataCy}
      height={height}
      width={width}
      isDefaultIcon={isDefaultIcon}
    />
  );
};
